{
  "#DATA_CARRIER": {
    "TITLE": "Baumarkt",
    "MODULE": "Baumarkt"
  }
}
